// extracted by mini-css-extract-plugin
module.exports = {"actions":"roleItem_actions_2BPgYtB","button":"roleItem_button_b4_GTq9","disabled":"roleItem_disabled_3HFYbNh","label":"roleItem_label_3uYa9G3"};